import React, { createContext, useContext, useState } from 'react';

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'fa', label: 'Farsi' }
];

const I18nContext = createContext(null);
const dummyT = (key) => {
  const dict = {
    nav_owner: 'Owner Panel',
    nav_home: 'Home',
    nav_charts: 'Live Charts',
    nav_signals: 'AI Signals',
    nav_autotrade: 'AutoTrade',
    nav_manual: 'Manual Trade',
    nav_scanner: 'Memecoin Scanner',
    nav_backtest: '5x5 Backtest',
    nav_positions: 'Positions',
    nav_nft: 'NFT Collection',
    nav_assistant: 'AI Assistant',
    nav_exchange: 'Exchange',
    nav_settings: 'Settings',
    nav_subscription: 'Premium Plan',
    nav_guide: 'Beginner Guide',
    logout: 'Logout'
  };
  return dict[key] || key;
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState('en');
  return (
    <I18nContext.Provider value={{ lang, setLang, t: dummyT, LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext) || { t: dummyT, lang: 'en', setLang: () => {}, LANGUAGES };
}

export function useTranslation() {
  return { t: dummyT, i18n: { language: 'en', changeLanguage: () => {} } };
}

export function renderKey(key) { return key; }
export function tReason(reason) { return reason; }
